export const appConstants = {
  nome: 'Codex',
  versao: '1.0.0',
  dataCompilacao: '',
  solAppKey: 'codex',
  chaveUsuarioSessao: 'codex:usuarioSessao',
  chaveDataUltimoRefreshToken: 'codex:ultimoRefreshToken',
  chaveRedirecionarPara: 'codex:redirecionarPara',
  chaveRecursos: 'codex:recursos',
  duracaoTokenMinutos: 15,
  cores: [
    '#42A5F5', '#FFCE56', '#FF6384', '#9CCC65', '#4BC0C0', '#E7E9ED', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3',
    '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722',
    '#795548', '#9E9E9E', '#607D8B', '#ffcdd2', '#F8BBD0', '#E1BEE7', '#D1C4E9', '#C5CAE9', '#BBDEFB', '#B3E5FC'
  ]
};
